<template>
  <div>
    <video ref="videoPlayer" class="video-js"></video>
  </div>
</template>

<script>
import videojs from "video.js";
import axios from "axios";
export default {
  name: "VideoPlayer",
  props: {
    options: {
      type: Object,
      default() {
        return {
          autoSetup: false
        };
      }
    }
  },
  data() {
    return {
      player: null
    };
  },
  async mounted() {
    await axios
      .get(`${process.env.VUE_APP_API_URL}/api/videos/${this.$route.params.id}`)
      .then(res => {
        this.options.sources[0].src = `${process.env.VUE_APP_API_URL}/api/videos/watch/${this.$route.params.id}`;
        this.options.autoplay = res.data.autoplay;
        this.options.controls = res.data.controls;
        this.options.loop = res.data.loop;
        this.options.muted = res.data.muted;
        this.player = videojs(
          this.$refs.videoPlayer,
          this.options,
          function onPlayerReady() {}
        );
      });
  },
  beforeDestroy() {
    if (this.player) {
      this.player.reset();
    }
  }
};
</script>


<style src="video.js/dist/video-js.css">
</style>
